// Central image helper — uses Unsplash for realistic taxi/car imagery
export const img = (id, w = 800, h = 600) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80${
    h ? `&h=${h}` : ""
  }`;

export const IMAGES = {
  heroCab: img("1559030623-0226b1241edd", 1200, 900),
  taxiYellow: img("1549317661-bd32c8ce0db2", 900, 650),
  cityNight: img("1502920917128-1aa500764cbd", 1200, 800),
  driver: img("1633332755192-727a05c4013d", 800, 800),
  fleet: img("1511919884226-fd3cad34687c", 900, 650),
  road: img("1503376780353-7e6692767b70", 1200, 700),
  heroTaxi: "https://images.pexels.com/photos/116675/pexels-photo-116675.jpeg?auto=compress&cs=tinysrgb&w=1600",
  aboutPro1: "https://images.pexels.com/photos/2519374/pexels-photo-2519374.jpeg?auto=compress&cs=tinysrgb&w=900",
  aboutPro2: "https://images.pexels.com/photos/170811/pexels-photo-170811.jpeg?auto=compress&cs=tinysrgb&w=900",
  contact: img("1449965408869-eaa3f722e40d", 1000, 700),
  about1: img("1556122071-e404eaedb77f", 700, 800),
  about2: img("1571068316344-75bc76f77890", 700, 520),
};

// Local fleet vehicle photos (public/images/cars)
export const CARS = {  saloon: "/images/cars/saloon-car.png",
  estate: "/images/cars/estate-car.png",
  executive: "/images/cars/executive-car.png",
  mpv: "/images/cars/mpv-vehicle.png",
  minibus: "/images/cars/minibus-8seater.png",
  wheelchair: "/images/cars/wheelchair-vehicle.png",
  standard: "/images/cars/standard-taxi.png",
};

export const ABOUT_APP = "/images/about-app.png";
